module.exports = __webpack_public_path__ + "static/img/gamecenter.dcb5370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gamecenter.png
// module id = 553
// module chunks = 1